import { Injectable } from '@angular/core';
//import { isNumber, toInteger, padNumber } from '@ng-bootstrap/ng-bootstrap/util/util';
import {
  NgbDateParserFormatter,
  NgbDateStruct
} from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct {
    if (value) {
      const dateParts = value.trim().split('/');
      if (dateParts.length === 1 && this.isNumber(dateParts[0])) {
        return { day: null, month: this.toInteger(dateParts[0]), year: null };
      } else if (
        dateParts.length === 2 &&
        this.isNumber(dateParts[0]) &&
        this.isNumber(dateParts[1])
      ) {
        return {
          day: this.toInteger(dateParts[1]),
          month: this.toInteger(dateParts[0]),
          year: null
        };
      } else if (
        dateParts.length === 3 &&
        this.isNumber(dateParts[0]) &&
        this.isNumber(dateParts[1]) &&
        this.isNumber(dateParts[2])
      ) {
        return {
          day: this.toInteger(dateParts[1]),
          month: this.toInteger(dateParts[0]),
          year: this.toInteger(dateParts[2])
        };
      }
    }
    return null;
  }
  public isNumber(value: any): value is number {
    return !isNaN(this.toInteger(value));
  }
  public toInteger(value: any): number {
    return parseInt(`${value}`, 10);
  }
  public padNumber(value: number) {
    if (this.isNumber(value)) {
      return `0${value}`.slice(-2);
    } else {
      return '';
    }
  }
  format(date: NgbDateStruct): string {
    return date
      ? `${this.isNumber(date.month) ? this.padNumber(date.month) : ''}/${
          this.isNumber(date.day) ? this.padNumber(date.day) : ''
        }/${date.year}`
      : '';
  }
}
